import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multiselector-dropdown-vehicle-type',
  templateUrl: './multiselector-dropdown-vehicle-type.component.html',
  styleUrls: ['./multiselector-dropdown-vehicle-type.component.css']
})
export class MultiselectorDropdownVehicleTypeComponent implements OnInit {

  @Input() list: any[];
  @Input() index: number;
  showDropDown = false;
  clicked=false;
  @Output() shareVehicleTypeCheckedList = new EventEmitter<any>();
  checkedList: any[];
  checkedListName: any[];
  currentSelected: {};

  constructor() {
    this.checkedList = [];
    this.checkedListName = [];
  }

  ngOnInit(): void {
    // This is intentional
  }

  ngOnChanges(_changes: any) {
    if (this.list) {
      let cnt = 1;
      this.checkedList = [];
      this.checkedListName = [];
      this.list.forEach(element => {
        if (element.checked && element.id>0) {
          cnt++;
          this.checkedList.push(element);
          this.checkedListName.push(element.name);
        }
      });
      if (this.list.length === cnt) {
        this.checkedListName = [];
        this.list[0].checked=true;
        this.checkedListName.push(this.list[0].name);
      }
    }
  }

  getSelectedValue(item: any) {
    if (item.checked) {
      //if status true and selected All
      if (item.name === 'All') {
        this.checkedList = [];
        this.checkedListName = [];
        this.checkedListName.push(item.name);
        this.list.forEach(element => {
          element.checked = true;
          if (element.id > 0) {
            this.checkedList.push(element);
          }
        });
      }
      else {
        this.checkedList.push(item);
        if (this.list.length - 1 === this.checkedList.length) {
          this.checkedListName=[];
          this.checkedListName.push(this.list[0].name);
          this.list[0].checked = true;
        } else {
          this.checkedListName.push(item.name);
        }
      }
    } else {
      if (item.name === 'All') {
        this.checkedList = [];
        this.checkedListName = [];
        this.list.forEach(element => {
          element.checked = false;
        });
      }
      else {
        let index = this.checkedList.indexOf(item);
        this.checkedList.splice(index, 1);
        if (this.checkedList.length < this.list.length) 
        {
            this.list[0].checked = false;
        }
        this.checkedListName = [];
        this.checkedList.forEach(x => this.checkedListName.push(x.name));
      }
    }
    this.currentSelected = { item };

    //share checked list
    this.shareCheckedlist();
  }

  shareCheckedlist() {
    this.shareVehicleTypeCheckedList.emit({ checkedList: this.checkedList, index: this.index });
  }

  btnClicked()
  {
    this.clicked=true;
    this.showDropDown=!this.showDropDown;
  }
}
